import { LazyPage } from '../components/loadable';


export { default as HomePage } from './home/home';

export const CaAnPage = LazyPage(import('./danh-muc/ca-an'));
export const DangKyCaAnPage = LazyPage(import('./danh-muc/dang-ky-ca-an'));
export const FoThucDonLayout = LazyPage(import('./thuc-don/FoThucDonLayout'));
export const DotDangKyAnPage = LazyPage(import('./dang-ky-an/dot-dang-ky-an'));
export const DangKyHocSinhPage = LazyPage(import('./dang-ky-an/dang-ky-hoc-sinh'));
export const XacNhanAnHocSinhPage = LazyPage(import('./dang-ky-an/xac-nhan-an-hoc-sinh'));
export const DiemDanhAnPage = LazyPage(import('./dang-ky-an/diem-danh-an'));
export const BaoCaoDiemDanhPage = LazyPage(import('./bao-cao/bao-cao-diem-danh'));
export const CauHinhDonGiaPage = LazyPage(import('./finance/don-gia'));
export const DanhSachCongNoPage = LazyPage(import('./finance/cong-no'));


